import { createI18n } from "vue-i18n";

function loadLocaleMessages() {
  const locales = require.context(
    "@/locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: process.env.VUE_APP_I18N_LOCALE || "sv-SE",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en-GB",
  messages: loadLocaleMessages(),
});

export function getI18nLocale() {
  return typeof i18n.global.locale === "string"
    ? i18n.global.locale
    : i18n.global.locale.value;
}

export function setI18nLocale(locale) {
  if (typeof i18n.global.locale === "string") {
    i18n.global.locale = locale;
    return;
  }

  i18n.global.locale.value = locale;
}

export default i18n;
